import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import esCommon from './locales/es-AR/common.json';
import esCatalog from './locales/es-AR/catalog.json';
import esCart from './locales/es-AR/cart.json';
import esAccount from './locales/es-AR/account.json';
import enCommon from './locales/en/common.json';

const resources = {
  'es-AR': {
    common: esCommon,
    catalog: esCatalog,
    cart: esCart,
    account: esAccount,
  },
  en: {
    common: enCommon,
    catalog: esCatalog,
    cart: esCart,
    account: esAccount,
  },
};

export const initI18n = (defaultLocale = 'es-AR') => {
  if (i18n.isInitialized) return i18n;

  i18n.use(initReactI18next).init({
    resources,
    lng: defaultLocale,
    fallbackLng: 'es-AR',
    defaultNS: 'common',
    interpolation: { escapeValue: false },
  });

  return i18n;
};

export default i18n;
